/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export class TimeoutError extends Error {
	constructor(message: string) {
		super(`Resource timed out: ${message}`);
		this.name = 'TimeoutError';
	}
}
